import type { SystemActivityCategory } from '../../types/systemActivity';

export const WORKSPACE_ACTIVITY_SEARCH_EVENT = 'workspace-activity:search';
export const WORKSPACE_ACTIVITY_FILTER_EVENT = 'workspace-activity:filter';
export const WORKSPACE_ACTIVITY_EXPORT_EVENT = 'workspace-activity:export';
export const WORKSPACE_ACTIVITY_STATE_EVENT = 'workspace-activity:state-change';

export const WORKSPACE_ACTIVITY_CATEGORY_OPTIONS: ReadonlyArray<{
  id: SystemActivityCategory | 'all';
  label: string;
}> = [
  { id: 'all', label: 'All activity' },
  { id: 'company', label: 'Company' },
  { id: 'user', label: 'Users' },
  { id: 'project', label: 'Projects' },
  { id: 'task', label: 'Tasks' },
  { id: 'tender', label: 'Tenders' },
  { id: 'payment', label: 'Payments' },
  { id: 'integration', label: 'Integrations' },
  { id: 'system', label: 'System' },
];
